module.exports = __webpack_public_path__ + "static/media/biocertica-id-logo-with-text-black-vertical.d47122d4.svg";